/**
 * StepButton component for RMC Order Edit
 */

import {ControlledInput} from '@hm/fundamental'
import {mdiChevronRight} from '@mdi/js'
import {Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {EditableFieldType} from '../RmcOrderEditStepView'

interface StepButtonProps {
  label: string
  value: string
  editStepType: EditableFieldType
  onClick?: () => void
  isValid: boolean
  error?: string
  requiresDispatchApproval?: boolean
}

export const StepButton: React.FC<StepButtonProps> = ({
  label,
  value,
  editStepType,
  onClick,
  isValid,
  error,
  requiresDispatchApproval = false
}) => {
  const {t} = useTranslation()

  // Map EditStepType to specific test IDs
  const getTestId = (stepType: EditableFieldType): string => {
    switch (stepType) {
      case EditableFieldType.MATERIAL:
        return 'step-button-mix-type'
      case EditableFieldType.QUANTITY:
        return 'step-button-quantity'
      case EditableFieldType.INTERVALS:
        return 'step-button-interval'
      case EditableFieldType.DATE:
        return 'step-button-date'
      case EditableFieldType.TIME:
        return 'step-button-start-time'
      case EditableFieldType.USAGE:
        return 'step-button-usage'
      case EditableFieldType.UNLOADING_METHOD:
        return 'step-button-unloading-method'
      case EditableFieldType.MIX_CHARACTERISTICS:
        return 'step-button-mix-characteristics'
      default:
        return `step-button-${stepType}`
    }
  }

  const hasValidationWarning = !isValid

  return (
    <Box
      onClick={onClick}
      sx={{
        '& *': {
          cursor: 'pointer !important'
        },
        '&:hover': {
          backgroundColor: '#e3f2fd'
        }
      }}
    >
      <ControlledInput
        name={label}
        label={label}
        value={value}
        icon={mdiChevronRight}
        onIconClick={onClick}
        data-test-id={getTestId(editStepType)}
        state={requiresDispatchApproval ? 'warning' : hasValidationWarning ? 'error' : undefined}
        hint={
          requiresDispatchApproval
            ? t(
                'orderIntake.rmc.orderManagement.requiresDispatchApproval',
                'Requires dispatch approval'
              )
            : hasValidationWarning
              ? error
              : undefined
        }
      />
    </Box>
  )
}
